import React from 'react';
import $ from "jquery";

import Server from '../../../functions/server';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Dropdown, Grid, Input, Button, Form, TextArea, Image, Card } from 'semantic-ui-react';

export default class App extends React.Component {

    state = {
        data: [], handleChange: '', serialNumber: this.getFormatedDate(new Date()),
    }

    getFormatedDate(dates, interval) {
        if (interval > 0) {
          dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
        }
        let month = dates.getMonth() + 1; let date = dates.getDate();
        month = (month >= 10) ? month : "0"+ month;
        date = (date >= 10) ? date : "0" + date;
        let x = dates.getFullYear() + "-" + month + "-" + date;
        if (interval == 7) {
          x = dates.getFullYear() + "-" + month + "-01";
        }
        return x;
      }

    getJobCardByCustomerId = () => {
        let context = this;
        let { customer } = this.props;
        $.ajax({
            type: 'POST', data: { customer }, 
            url: Server() + 'Sales/JobCard/getJobCardByCustomerId.php',
            success: function(data) {
            try {
                data = JSON.parse(data);
                context.setState({ data, JobCardsDialog: true })
            } catch (error) {
                
            }
            },
            error: function(e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });
    }

    saveSpares = (jobcard_id) => {
        let context = this;
        let { items, customer } = this.props;
        let { serialNumber } = this.state;
        let data = { items: JSON.stringify(items), customer, jobcard_id, serialNumber };
        context.setState({ message: "false", load: true });
        console.log(items);
        $.ajax({
            type: 'POST', data, 
            url: Server() + 'Sales/JobCard/SaveSpares.php',
            success: function(data) {
                console.log(data);
                if (data == 1) {
                    context.setState({ JobCardsDialog: false, load: false })
                    context.props.refreshAfterMovingSparesToService();
                }
                else {
                    alert('Error')
                }
            },
            error: function(e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });
    }



    handleChange = name => event => { this.setState({ [name]: event.target.value }) }

    render() {
        let { JobCardsDialog, data, JobMasterCreationDialog } = this.state;
        return (
            <div>
                <Button fluid primary onClick={this.getJobCardByCustomerId}>Service</Button>
                <Dialog fullWidth={true}  maxWidth={'lg'}
                    open={JobCardsDialog} onClose={ () => { this.setState({ JobCardsDialog: false }) }} 
                    aria-labelledby="max-width-dialog-title">
                    <DialogTitle id="max-width-dialog-title">Job Card</DialogTitle>
                    <DialogContent>
                        {
                            data.length == 0 ?
                            <center>
                                There Is No Job Present!!!<br/>
                            </center>:
                            <div>
                                <br/><b>Serial Number</b>
                                <Input value={this.state.serialNumber} disabled={true} /><br/><br/>
                                <Grid>
                                    { 
                                        data.map((c) => {
                                            if (c.status == 1 || c.status == '1') {
                                                return (
                                                    <Grid.Column mobile={16} tablet={6} computer={4}>
                                                        <Card style={{cursor: 'pointer'}} onClick={ () => this.saveSpares(c.id)}>
                                                            <Card.Content>
                                                                <Card.Header>{"JobCard ID #"+c.id}</Card.Header>
                                                                <Card.Meta>
                                                                    <span className='date'><b>{c.machine}</b></span>
                                                                </Card.Meta>
                                                                <Card.Description>
                                                                    {c.issue}
                                                                </Card.Description>
                                                            </Card.Content>
                                                        </Card>
                                                    </Grid.Column>
                                                )
                                            }
                                        })

                                    }
                                </Grid>
                            </div>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ JobCardsDialog: false }) }}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}